// client/src/components/HomeComponent.js
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

function HomeComponent() {
  const { isAuthenticated, token } = useContext(AuthContext);
  const loggedIn = Boolean(token || isAuthenticated);

  return (
    <>
      {/* Features Grid */}
      <div className="features-grid">
        <div className="feature-card">
          <div className="feature-icon">
            <i className="fas fa-search-dollar" aria-hidden="true"></i>
          </div>
          <h3>Erweiterte Aktiensuche</h3>
          <p>Filtere Aktien nach Kriterien wie Dividendenrendite, KGV, Branche, Land und Wachstumsprognosen.</p>
          <Link to="/search" className="feature-link">
            Aktiensuche starten
            <i className="fas fa-arrow-right" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="feature-card">
          <div className="feature-icon">
            <i className="fas fa-chart-line" aria-hidden="true"></i>
          </div>
          <h3>Portfolio-Verwaltung</h3>
          <p>Lege dein Portfolio an, verfolge Wertentwicklung und Dividenden und behalte die Verteilung nach Sektoren und Ländern im Blick.</p>
          {loggedIn ? (
            <Link to="/portfolio" className="feature-link">
              Zum Portfolio
              <i className="fas fa-arrow-right" aria-hidden="true"></i>
            </Link>
          ) : (
            <Link to="/login" className="feature-link">
              Jetzt anmelden
              <i className="fas fa-arrow-right" aria-hidden="true"></i>
            </Link>
          )}
        </div>

        <div className="feature-card">
          <div className="feature-icon">
            <i className="fas fa-chart-pie" aria-hidden="true"></i>
          </div>
          <h3>Detaillierte Analyse</h3>
          <p>Umfassende Finanzkennzahlen, Wachstumsprognosen und ein Bewertungs-Score im Branchenvergleich für fundierte Entscheidungen.</p>
          <Link to="/search-explained" className="feature-link">
            Kennzahlen verstehen
            <i className="fas fa-arrow-right" aria-hidden="true"></i>
          </Link>
        </div>
      </div>

      {/* CTA Section */}
      <div className="cta-content">
        <h2>Bereit für smarte Investitionen?</h2>
        <p>Nutze DynaStoxx kostenlos für deine Investmentrecherche.</p>
        {loggedIn ? (
          <Link to="/search" className="home-btn home-btn--primary">
            <i className="fas fa-search" aria-hidden="true"></i>
            Suche starten
          </Link>
        ) : (
          <div className="cta-buttons">
            <Link to="/register" className="home-btn home-btn--primary">
              <i className="fas fa-user-plus" aria-hidden="true"></i>
              Kostenloses Konto erstellen
            </Link>
            <Link to="/login" className="text-button">
              Bereits registriert? Hier anmelden
            </Link>
          </div>
        )}
      </div>
    </>
  );
}

export default HomeComponent;
